<div class="main-content denuncias-detalle-page">
  <div class="container-fluid">

    <!-- Estado: cargando -->
    <div class="det-state det-state--loading" *ngIf="cargando">
      <span class="material-icons det-spinner">hourglass_top</span>
      <p>Cargando denuncia...</p>
    </div>

    <!-- Estado: error sin datos -->
    <div class="det-state det-state--error" *ngIf="!cargando && mensajeError && !denuncia.id_denuncia">
      <span class="material-icons">error_outline</span>
      <p>{{ mensajeError }}</p>
      <button class="det-btn det-btn--ghost" (click)="volver()">
        <span class="material-icons">arrow_back</span>
        Volver al Kanban
      </button>
    </div>

    <!-- Contenido principal -->
    <ng-container *ngIf="!cargando && denuncia.id_denuncia">

      <div id="detDocumento">
      <!-- Encabezado de documento -->
      <div class="det-doc-header">
        <div class="det-doc-header__left">
          <button class="det-back-btn det-no-export" (click)="volver()" title="Volver al Kanban">
            <span class="material-icons">arrow_back</span>
          </button>
          <h1 class="det-doc-header__codigo">{{ denuncia.codigoSeguimiento }}</h1>
          <div class="det-doc-badges">
            <span class="det-doc-badge det-doc-badge--status" [ngClass]="getBadgeClass(denuncia.id_estatus)">
              {{ denuncia.nombreEstatus }}
            </span>
            <span class="det-doc-badge det-doc-badge--priority" *ngIf="denuncia.requiereProteccion">
              <span class="material-icons">priority_high</span>
              Prioridad Alta
            </span>
            <span class="det-doc-badge det-doc-badge--anonima" *ngIf="denuncia.tipoDenuncia === 'ANONIMA'">
              <span class="material-icons">person_off</span>
              Anónima
            </span>
          </div>
        </div>
        <div class="det-doc-header__actions det-no-export">
          <button class="det-action-btn" (click)="exportarPdf()" [disabled]="exportando">
            <span class="material-icons">{{ exportando ? 'hourglass_empty' : 'ios_share' }}</span>
            {{ exportando ? 'Exportando...' : 'Exportar PDF' }}
          </button>
        </div>
      </div>

      <!-- Layout principal -->
      <div class="det-layout">

        <!-- Columna izquierda: información -->
        <div class="det-col-info">

          <!-- Hechos reportados -->
          <section class="det-card">
            <h2 class="det-card__title">
              <span class="material-icons">description</span>
              Hechos reportados
            </h2>
            <div class="det-hechos">{{ denuncia.hechos }}</div>
          </section>

          <!-- Info pair: Seguridad + Metadatos -->
          <div class="det-info-pair">

            <!-- Información de seguridad -->
            <section class="det-card det-card--info">
              <h2 class="det-card__title">Información de seguridad</h2>
              <div class="det-info-rows">
                <div class="det-info-row">
                  <span class="det-info-row__label">
                    <span class="material-icons">lock</span>
                    Anónimo
                  </span>
                  <span class="det-info-row__value">{{ denuncia.tipoDenuncia === 'ANONIMA' ? 'Sí' : 'No' }}</span>
                </div>
                <div class="det-info-row">
                  <span class="det-info-row__label">
                    <span class="material-icons">shield</span>
                    Requiere Protección
                  </span>
                  <span class="det-info-row__value" [class.det-info-row__value--alert]="denuncia.requiereProteccion">
                    {{ denuncia.requiereProteccion || 'No' }}
                  </span>
                </div>
                <ng-container *ngIf="denuncia.tipoDenuncia === 'CONFIDENCIAL'">
                  <div class="det-info-row">
                    <span class="det-info-row__label">
                      <span class="material-icons">person</span>
                      Denunciante
                    </span>
                    <span class="det-info-row__value">{{ denuncia.nombre }} {{ denuncia.apellidos }}</span>
                  </div>
                  <div class="det-info-row" *ngIf="denuncia.telefono">
                    <span class="det-info-row__label">
                      <span class="material-icons">phone</span>
                      Teléfono
                    </span>
                    <span class="det-info-row__value">{{ denuncia.telefono }}</span>
                  </div>
                  <div class="det-info-row" *ngIf="denuncia.email">
                    <span class="det-info-row__label">
                      <span class="material-icons">mail</span>
                      Correo
                    </span>
                    <span class="det-info-row__value">{{ denuncia.email }}</span>
                  </div>
                </ng-container>
              </div>
            </section>

            <!-- Metadatos de registro -->
            <section class="det-card det-card--info">
              <h2 class="det-card__title">Información del registro</h2>
              <div class="det-info-rows">
                <div class="det-info-row">
                  <span class="det-info-row__label">
                    <span class="material-icons">calendar_today</span>
                    Fecha de Envío
                  </span>
                  <span class="det-info-row__value">{{ denuncia.fechaRegistro | date:'d MMM, yyyy' | titlecase }}</span>
                </div>
                <div class="det-info-row">
                  <span class="det-info-row__label">
                    <span class="material-icons">category</span>
                    Categoría
                  </span>
                  <span class="det-info-row__value">{{ denuncia.nombreCategoria || 'Sin categoría' }}</span>
                </div>
                <div class="det-info-row">
                  <span class="det-info-row__label">
                    <span class="material-icons">language</span>
                    Canal de Reporte
                  </span>
                  <span class="det-info-row__value">Línea Ética Web</span>
                </div>
                <div class="det-info-row" *ngIf="denuncia.lugarOcurrencia">
                  <span class="det-info-row__label">
                    <span class="material-icons">place</span>
                    Lugar
                  </span>
                  <span class="det-info-row__value">{{ denuncia.lugarOcurrencia }}</span>
                </div>
              </div>
            </section>

          </div>

          <!-- Evidencias -->
          <section class="det-card">
            <div class="det-evidencias-header">
              <h2 class="det-card__title">
                <span class="material-icons">attach_file</span>
                Evidencias adjuntas
                <span class="det-card__count" *ngIf="evidencias.length > 0">{{ evidencias.length }}</span>
              </h2>
              <button class="det-download-all det-no-export" type="button"
                *ngIf="evidencias.length > 0" (click)="descargarTodo()" [disabled]="descargando">
                <span class="material-icons">{{ descargando ? 'hourglass_empty' : 'download' }}</span>
                {{ descargando ? 'Descargando...' : 'Descargar todo' }}
              </button>
            </div>

            <div class="det-evidencias-grid" *ngIf="evidencias.length > 0">
              <div class="det-evidencia-item" *ngFor="let ev of evidencias">

                <!-- Imagen -->
                <ng-container *ngIf="esImagen(ev)">
                  <button class="det-evidencia-thumb" type="button"
                    *ngIf="evidenciaImgs.has(ev.id_evidencia)"
                    (click)="verEvidencia(ev)">
                    <img [src]="evidenciaImgs.get(ev.id_evidencia)"
                      [alt]="ev.nombreArchivo"
                      class="det-evidencia-img">
                    <div class="det-evidencia-overlay">
                      <span class="material-icons">zoom_in</span>
                    </div>
                  </button>
                  <div class="det-evidencia-thumb det-evidencia-thumb--loading"
                    *ngIf="evidenciasCargando.has(ev.id_evidencia)">
                    <span class="material-icons det-spinner">hourglass_top</span>
                  </div>
                  <button class="det-evidencia-thumb det-evidencia-thumb--error" type="button"
                    *ngIf="evidenciasFallidas.has(ev.id_evidencia)"
                    (click)="verEvidencia(ev)"
                    [title]="'Reintentar / ver: ' + ev.nombreArchivo">
                    <span class="material-icons">broken_image</span>
                  </button>
                </ng-container>

                <!-- Archivo no imagen -->
                <ng-container *ngIf="!esImagen(ev)">
                  <button class="det-evidencia-thumb det-evidencia-file" type="button"
                    (click)="verEvidencia(ev)" [title]="'Ver: ' + ev.nombreArchivo">
                    <span class="material-icons">description</span>
                    <div class="det-evidencia-overlay">
                      <span class="material-icons">visibility</span>
                    </div>
                  </button>
                </ng-container>

                <div class="det-evidencia-meta">
                  <span class="det-evidencia-nombre" [title]="ev.nombreArchivo">{{ ev.nombreArchivo }}</span>
                  <span class="det-evidencia-size">{{ formatBytes(ev.tamanio) }}</span>
                </div>
              </div>
            </div>

            <div class="det-evidencias-empty" *ngIf="evidencias.length === 0">
              <span class="material-icons">attach_file</span>
              <span>Sin evidencias adjuntas</span>
            </div>
          </section>

        </div>

        <!-- Columna derecha: gestión -->
        <div class="det-col-side">

          <!-- Panel de gestión -->
          <section class="det-card det-card--gestion">
            <h2 class="det-card__title">
              <span class="material-icons">manage_accounts</span>
              Gestión de caso
            </h2>

            <div class="det-form-group">
              <label class="det-label" for="detalleDenunciaEstatus">Estado actual</label>
              <select id="detalleDenunciaEstatus" class="det-select" [(ngModel)]="denuncia.id_estatus" [disabled]="denunciaCerrada">
                <option *ngFor="let e of estatusList" [ngValue]="e.id">{{ e.nombre }}</option>
              </select>
              <p class="det-bloqueo-nota" *ngIf="denunciaCerrada">
                <span class="material-icons">lock</span>
                Denuncia cerrada: no se puede reabrir ni modificar su estado.
              </p>
            </div>

            <div class="det-form-group">
              <label class="det-label" for="detalleDenunciaInvestigador">Investigador asignado</label>
              <select id="detalleDenunciaInvestigador" class="det-select" [(ngModel)]="idInvestigadorSel" [disabled]="denunciaCerrada">
                <option [ngValue]="null">Sin asignar</option>
                <option *ngFor="let emp of investigadores" [ngValue]="idUsuarioEmpleado(emp)">
                  {{ nombreEmpleado(emp) }}
                </option>
              </select>
              <p class="det-asignado-actual" *ngIf="denuncia.nombreUsuarioAsignado">
                <span class="det-investigador-avatar">{{ getInitials(denuncia.nombreUsuarioAsignado) }}</span>
                Asignado: <strong>{{ denuncia.nombreUsuarioAsignado }}</strong>
              </p>
            </div>

            <div class="det-feedback det-feedback--ok" *ngIf="mensajeExito">
              <span class="material-icons">check_circle</span>
              {{ mensajeExito }}
            </div>
            <div class="det-feedback det-feedback--err" *ngIf="mensajeError && denuncia.id_denuncia">
              <span class="material-icons">warning</span>
              {{ mensajeError }}
            </div>

            <button class="det-btn det-btn--primary det-btn--full"
              (click)="guardarCambios()" [disabled]="guardando || denunciaCerrada">
              <span class="material-icons">{{ guardando ? 'hourglass_empty' : 'save' }}</span>
              {{ guardando ? 'Guardando...' : 'Guardar cambios' }}
            </button>
          </section>

          <!-- Comentarios internos -->
          <section class="det-card det-card--comentarios">
            <h2 class="det-card__title">
              <span class="material-icons">comment</span>
              Comentarios internos
              <span class="det-count-badge" *ngIf="comentarios.length > 0">{{ comentarios.length }}</span>
            </h2>

            <div class="det-comments">
              <div class="det-comment-empty" *ngIf="comentarios.length === 0">
                Sin comentarios internos.
              </div>
              <div class="det-comment-item" *ngFor="let c of comentarios">
                <div class="det-comment-avatar">{{ getInitials(c.nombreUsuario) }}</div>
                <div class="det-comment-content">
                  <div class="det-comment-meta">
                    <strong>{{ c.nombreUsuario }}</strong>
                    <span>{{ c.fecha | date:'d MMM, HH:mm' | titlecase }}</span>
                  </div>
                  <div class="det-bubble">{{ c.comentario }}</div>
                </div>
              </div>
            </div>

            <div class="det-compose">
              <textarea class="det-textarea" aria-label="Escribe una nota interna" [(ngModel)]="nuevoComentario" rows="2"
                placeholder="Escribe una nota interna..."></textarea>
              <button class="det-compose-send"
                (click)="agregarComentario()"
                [disabled]="enviandoComentario || !nuevoComentario.trim()">
                <span class="material-icons">send</span>
              </button>
            </div>
          </section>

          <!-- Historial de actividad -->
          <section class="det-card det-card--historial">
            <h2 class="det-card__title">
              <span class="material-icons">history</span>
              Historial de actividad
            </h2>

            <div class="det-timeline-empty" *ngIf="historial.length === 0">
              Sin cambios registrados
            </div>

            <div class="det-timeline">
              <div class="det-timeline-item" *ngFor="let h of historial">
                <div class="det-timeline-dot"></div>
                <div class="det-timeline-body">
                  <span class="det-timeline-estatus">{{ h.nombreEstatusNuevo }}</span>
                  <span class="det-timeline-meta">
                    {{ h.nombreUsuario }} · {{ h.fecha | date:'d MMM, HH:mm' | titlecase }}
                  </span>
                  <span class="det-timeline-obs" *ngIf="h.observacion">{{ h.observacion }}</span>
                </div>
              </div>
            </div>
          </section>

        </div>
      </div>
      </div>

    </ng-container>
  </div>
</div>

<!-- Visor de evidencias -->
<div class="det-lightbox" *ngIf="visorAbierto" (click)="cerrarVisor()" (keydown.enter)="$event.target === $event.currentTarget ? cerrarVisor() : null">
  <div class="det-lightbox__inner" (click)="$event.stopPropagation()" (keydown.enter)="$event.target === $event.currentTarget ? $event.stopPropagation() : null">
    <button class="det-lightbox__close" (click)="cerrarVisor()" title="Cerrar">
      <span class="material-icons">close</span>
    </button>

    <img *ngIf="visorTipo === 'imagen' && visorUrl"
      [src]="visorUrl" [alt]="visorNombre" class="det-lightbox__img">

    <!-- Solo PDF, y con sandbox sin allow-scripts: la evidencia la subio un anonimo. -->
    <iframe *ngIf="visorTipo === 'pdf' && visorUrl" sandbox referrerpolicy="no-referrer"
      [src]="visorUrl" class="det-lightbox__frame" [title]="visorNombre"></iframe>

    <div class="det-lightbox__otro" *ngIf="visorTipo === 'otro'">
      <span class="material-icons">insert_drive_file</span>
      <p>Este archivo no se previsualiza (Word, Excel u otro formato): descárguelo para abrirlo.</p>
      <button class="det-btn det-btn--primary" (click)="descargarEvidencia(visorEvidencia)">
        <span class="material-icons">download</span>
        Descargar archivo
      </button>
    </div>

    <div class="det-lightbox__bar">
      <p class="det-lightbox__nombre">{{ visorNombre }}</p>
      <button class="det-lightbox__dl" *ngIf="visorTipo === 'pdf' && visorUrl" (click)="abrirEnPestana()"
        title="Abrir en otra pestaña">
        <span class="material-icons">open_in_new</span>
      </button>
      <button class="det-lightbox__dl" (click)="descargarEvidencia(visorEvidencia)" title="Descargar">
        <span class="material-icons">download</span>
      </button>
    </div>
  </div>
</div>
